import React, { useState } from "react";
import Procedures from "./Procedures";
import Diagnosis from "./Diagnosis";
import Consultants from "./Consultants";
import DrugList from "./DrugList";
import DrugGroups from "./DrugGroups";
import "./MasterData.css";

type TabId = "procedures" | "diagnosis" | "drugs" | "drug-groups" | "consultants";

export default function MasterTabs() {
  const [tab, setTab] = useState<TabId>("procedures");

  const tabs: { id: TabId; label: string; icon: string }[] = [
    { id: "procedures", label: "Procedures", icon: "🧾" },
    { id: "diagnosis", label: "Diagnosis", icon: "🩺" },
    { id: "drugs", label: "Drugs", icon: "💊" },
    { id: "drug-groups", label: "Drug Groups", icon: "📦" },
    { id: "consultants", label: "Consultants", icon: "👨⚕️" }
  ];

  return (
    <div className="mod-standalone-window master-shell">
      <div className="mod-window-header master-header">
        <div>
          <h2 className="master-title">⚙️ Master Data Configuration</h2>
          <p className="mod-text-muted">Manage system catalogs, procedures, drugs, and clinical mappings.</p>
        </div>
      </div>

      <div className="mod-sub-nav master-subnav">
        {tabs.map((t) => (
          <button
            key={t.id}
            type="button"
            className={`mod-sub-btn master-sub-btn ${tab === t.id ? "active" : ""}`}
            onClick={() => setTab(t.id)}
          >
            <span>{t.icon}</span>
            <span>{t.label}</span>
          </button>
        ))}
      </div>

      <div className="mod-panel-fade-in master-content-card">
        {tab === "procedures" && <Procedures />}
        {tab === "diagnosis" && <Diagnosis />}
        {tab === "drugs" && <DrugList />}
        {tab === "drug-groups" && <DrugGroups />}
        {tab === "consultants" && <Consultants />}
      </div>
    </div>
  );
}
